export function parseState(encodedState) {
  return JSON.parse(Buffer.from(encodedState, 'base64').toString());
}

export function encodeState(state) {
  return Buffer.from(JSON.stringify(state)).toString('base64');
}
